import { HttpClient } from '@angular/common/http';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManager, ResourceManagerService } from '@barthauer/abc/core/resources';
import { Observable } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { AuthConfiguration } from './../models/auth-config.model';
import { AuthConfigService } from './auth-config.service';
import { WebApiService } from './webapi.service';

export abstract class WebApiServiceWithAuthConfig extends WebApiService {
  constructor(
    httpClient: HttpClient,
    abcConfigService: AbcConfigService,
    protected authConfigService: AuthConfigService
  ) {
    super(httpClient, abcConfigService);

    ResourceManager.getLanguage(); //HACK: Initialization of ResourceManager, should be removed in the future
  }

  protected get currentAuthConfiguration(): Observable<AuthConfiguration> {
    return this.authConfigService.current;
  }

  protected getWebApiPOSTHeaders(): Observable<Map<string, string>> {
    return super
      .getWebApiPOSTHeaders()
      .pipe(
        concatMap((headersMap) =>
          this.currentAuthConfiguration.pipe(
            map((cfg) =>
              headersMap.set('Accept-Language', cfg.fixedCulture ?? ResourceManagerService.getCurrentLanguage())
            )
          )
        )
      );
  }
}
